var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"base-block"},[_c('div',{staticClass:"title"},[_vm._t("title")],2),_c('BaseCard',{staticClass:"card",class:{ noPadding: _vm.noPadding }},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }